/*jshint esversion: 9 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import TableOfUserManagement from './TableOfUserManagement';
import SelectionOfUserManagement from './SelectionOfUserManagement';
import Typography from '@material-ui/core/Typography';

const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
};
class userManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
    };
  }

  async componentDidMount() {
    document.title = "用户管理";
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          用户管理
        </Typography>
        <SelectionOfUserManagement />
        <TableOfUserManagement />
      </div>
    );
  }
}

const userManagement = observer(userManagementInner);

userManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(userManagement);

// for mobile template
// https://material-ui.com/store/previews/devias-kit/
// https://material-ui.com/store/previews/paperbase/
// https://demos.creative-tim.com/material-kit-react/#/